<div class="custom-container">
<div class="workspace-page" [class.dark]="themeService.isDark()">
  <app-header-style-one></app-header-style-one>



  <div class="workspace">
    <!-- Sidebar -->
    <aside class="sidebar">
      <div class="sidebar-header">
        <a routerLink="/" class="home-link" aria-label="Go to Home">← Home</a>
        <h2 class="title">Issues</h2>
      </div>

      <div class="years" *ngIf="!loading && years.length">
        <button
          *ngFor="let y of years"
          type="button"
          (click)="setYear(y)"
          [class.active]="y === activeYear">
          {{ y }}
        </button>
      </div>

      <div class="placeholder" *ngIf="loading">
        <div class="skeleton line"></div>
        <div class="skeleton line"></div>
        <div class="skeleton line short"></div>
      </div>

      <div class="empty" *ngIf="!loading && !years.length">
        No issues published yet.
      </div>

      <ul class="issue-list" *ngIf="!loading && years.length">
        <li *ngFor="let it of grouped[activeYear] || []; trackBy: trackById">
          <button
            type="button"
            (click)="select(it)"
            [class.active]="selected?.id === it.id"
            [title]="it.title">
            <span class="issue-title">{{ it.title }}</span>
            <span class="issue-meta">
              <span class="date">{{ formatDate(it.publish_date) }}</span>
              <span class="cat" *ngIf="it.category">· {{ it.category }}</span>
            </span>
          </button>
        </li>
      </ul>
    </aside>

    <!-- Viewer -->
    <main class="viewer">
      <div class="viewer-header" *ngIf="selected">
        <div class="info">
          <h3 class="v-title">{{ selected.title }}</h3>
          <div class="v-meta">
            <span class="v-date">{{ formatDate(selected.publish_date) }}</span>
            <span class="v-cat" *ngIf="selected.category">· {{ selected.category }}</span>
          </div>
        </div>
        <div class="actions">
          <a
            *ngIf="selected.pdf_path"
            class="btn btn-download"
            [href]="selected.pdf_path"
            target="_blank"
            rel="noopener">Download</a>
        </div>
      </div>

      <div class="pdf-wrap" *ngIf="!loading && safePdfUrl; else noSelection">
        <!-- IFRAME VIEWER (CORS-safe) -->
        <iframe
          class="pdf-frame"
          [src]="safePdfUrl"
          title="PDF viewer"
          loading="lazy">
        </iframe>

        <!-- If you later host PDFs on same origin, you can swap to ng2-pdf-viewer:
        <pdf-viewer [src]="selectedPdfUrl" [render-text]="true" [show-all]="true" [original-size]="false" [fit-to-page]="true"
                    style="display:block; width:100%; height:100%"></pdf-viewer>
        -->
      </div>

      <ng-template #noSelection>
        <div class="empty-view">
          <div *ngIf="loading" class="skeleton large"></div>
          <div *ngIf="!loading">Select an issue on the left to view.</div>
        </div>
      </ng-template>
    </main>
  </div>
</div>
</div>